// extracted by mini-css-extract-plugin
module.exports = {"actions":"ProductComponentForm_actions__23qHZ"};